/* eslint-disable */
import Storage from './storage';

export default class VuexState extends Storage {
    constructor() {
        super('vuex-state')
    }
}
